import { customTemplates } from "../../CustomTemplates.js";
import { isolatedTemplateRegistryMap } from "../IsolatedTemplates.js";
export function getTplStateStore(_ref, using, extraInfo) {
  let {
    tplStateStoreId,
    tplStateStoreMap
  } = _ref;
  if (!tplStateStoreId) {
    throw new Error(`Using "${using}" outside of a custom template${extraInfo !== null && extraInfo !== void 0 ? extraInfo : ""}`);
  }
  const store = tplStateStoreMap.get(tplStateStoreId);
  if (!store) {
    throw new Error(`Template state store is not found when using "${using}"${extraInfo !== null && extraInfo !== void 0 ? extraInfo : ""}.\nThis is a bug of Brick Next, please report it.`);
  }
  return store;
}
export function getTplHostElement(runtimeContext, using, extraInfo) {
  const store = getTplStateStore(runtimeContext, using, extraInfo);
  const hostElement = store.hostBrick.element;
  if (!hostElement) {
    throw new Error(`Template host element is gone when using "${using}"${extraInfo !== null && extraInfo !== void 0 ? extraInfo : ""}.\nThis is a bug of Brick Next, please report it.`);
  }
  return hostElement;
}
export function getTagNameOfCustomTemplate(brick, runtimeContext) {
  if (runtimeContext.isolatedRoot) {
    const registry = isolatedTemplateRegistryMap.get(runtimeContext.isolatedRoot);
    if (registry !== null && registry !== void 0 && registry.get(brick)) {
      return brick;
    }
    return false;
  }

  // When a template is registered by an app, it's namespace maybe missed.
  if (!brick.includes(".") && brick.startsWith("tpl-") && runtimeContext.app) {
    const tagName = `${runtimeContext.app.id}.${brick}`;
    if (customTemplates.get(tagName)) {
      return tagName;
    }
  }
  if (customTemplates.get(brick)) {
    return brick;
  }
  return false;
}
//# sourceMappingURL=utils.js.map